import React, { useEffect, useState } from 'react';
import { Button, FileUpload, Select } from '@insurancemenu/imenu-components-lib';
import { AcceptedFiles } from '@insurancemenu/imenu-components-lib/dist/types/FileUpload';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import StepHeader from 'components/common/headers/StepHeader';
import FormsSpinner from 'components/common/loaders/FormSpinner';
import { useHistory } from 'react-router-dom';
import { createStyles } from './styles';

const UploadExhibitsContent = observer((): JSX.Element => {
  const classes = createStyles();
  const history = useHistory();

  const {
    userStore: { sponsorId: currentSponsorId },
    triggerRenewalsStore: {
      loading,
      isFileUploadReset,
      getSponsorOptions,
      getEffectiveDateOptions,
      uploadAllExhibits,
      getAllDomains,
    },
  } = useRootStore();

  const now = new Date();
  now.setDate(1);
  const date = now.toISOString().slice(0, 10);

  const [files, setFiles] = useState<AcceptedFiles>({});
  const [sponsorId, setSponsorId] = useState(currentSponsorId);
  const [effectiveDate, setEffectiveDate] = useState(date);

  useEffect(() => {
    void getAllDomains();
  }, []);

  const onRedirectBack = (): void => {
    history.push('/trigger-renewals');
  };

  return (
    <div className={classes.content}>
      <div className={classes.actionBar}>
        <Select
          label="Sponsor Id"
          name="sponsorId"
          options={getSponsorOptions()}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>): void => {
            setSponsorId(e.target.value);
          }}
          value={sponsorId}
          width="23rem"
          validationPassed={!!sponsorId}
          validationMessage="Please select sponsor"
        />

        <Select
          label="Effective Date"
          name="effectiveDate"
          options={getEffectiveDateOptions()}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>): void => {
            setEffectiveDate(e.target.value);
          }}
          value={effectiveDate}
          width="23rem"
          validationPassed={!!effectiveDate}
          validationMessage="Please select effective date"
        />
      </div>
      <div className={classes.uploadsWrapper}>
        <StepHeader
          stepNumber="1"
          stepTitle="Import file exhibits"
          stepSubtitle={
            <p className={classes.subtitleStyled}>
              You can import your files here. Either drag and drop the files in the dotted box or select the button
              below to open up a dialogue box.
            </p>
          }
        />

        <div className={classes.uploadFileWrapper}>
          <FileUpload
            fileMimeTypes={[]}
            replaceSpecialCharacters={false}
            shouldBeReset={isFileUploadReset}
            onChange={(acceptedFiles): void => {
              setFiles(acceptedFiles);
            }}
          />
        </div>
      </div>
      <div className={classes.uploadsWrapper}>
        <StepHeader stepNumber="2" stepTitle="Upload exhibits" />
        <div className={classes.buttonWrapper}>
          <Button type="outlined" onClick={onRedirectBack} size="large">
            Back
          </Button>
          <Button
            onClick={(): void => {
              void uploadAllExhibits(files, sponsorId, effectiveDate);
            }}
            disabled={Object.keys(files).length === 0 || loading}
            size="large"
            color="primary"
          >
            Upload
          </Button>
        </div>
        {loading && <FormsSpinner display={loading} />}
      </div>
    </div>
  );
});

export default UploadExhibitsContent;
